import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AgGridCssClassEnum } from '../ag-grid-css-class.enum';

export interface BlendFilterRendererComponentParams {
  value: AgGridCssClassEnum;
}

@Component({
  selector: 'y42-blend-filter-renderer',
  templateUrl: './blend-filter-renderer.component.html',
  styleUrls: ['./blend-filter-renderer.component.scss'],
})
export class BlendFilterRendererComponent implements ICellRendererAngularComp {
  params: BlendFilterRendererComponentParams = {
    value: AgGridCssClassEnum.Normal,
  };
  agGridCssClassEnum = AgGridCssClassEnum;

  agInit(params: BlendFilterRendererComponentParams): void {
    this.params = params;
  }

  refresh(params: BlendFilterRendererComponentParams): boolean {
    this.params = params;
    return true;
  }
}
